import { Loader } from "apps/visits/packages/ui/src/components/loader";
import { useParams } from "react-router";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { useGetOrder } from "../../api/get-order";
import { ThankYou } from "../../components/thank-you";
import { useFinalOrderEvent } from "../../hooks/use-final-order-event";
import { useVouchersDistributionState } from "../../store/use-vouchers-distribution-state";
import { emitVouchersPurchase } from "../../utils/emit-vouchers-purchase";
import { configName } from "../config/config-name";

export const ThankYouPage = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const { voucherDistribution } = useVouchersDistributionState();

  const slug = voucherDistribution?.slug || "";

  const { data: orderData, isLoading: isOrderLoading } = useGetOrder({
    slug,
    configName,
    uuid,
    config: {
      enabled: !!uuid && !!voucherDistribution,
    },
  });

  useFinalOrderEvent({
    slug,
    configName,
    order: orderData?.order,
    onPurchase: emitVouchersPurchase,
    errorContext: "free-packages thank-you-page",
  });

  if (!voucherDistribution || isOrderLoading || !orderData)
    return (
      <div className="fixed inset-0 z-50 flex h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <IntersectionFadeIn className="mx-auto max-w-[1200px] py-10">
      <ThankYou
        vouchers={orderData.order.items}
        voucherDistribution={voucherDistribution}
        configName={configName}
        totalGrossPrice={orderData.order.totalGrossPrice}
      />
    </IntersectionFadeIn>
  );
};
